module.exports = __webpack_public_path__ + "img/logo-shiba888.0a479d52.png";